<script>
  export let widgets;
  export let orientation = "horizontal";

  import { debug } from "../store.js";

  import Heading from "./Heading.svelte";
  import Image from "./Image.svelte";
  import Text from "./Text.svelte";
  import Puzzle from "./Puzzle.svelte";
  import Benefit from "./Benefit.svelte";
  import Audio from "./Audio.svelte";
  import Video from "./Video.svelte";
  import Link from "./Link.svelte";
  import Button from "./Button.svelte";
  import Margin from "./Margin.svelte";
  import Embed from "./Embed.svelte";

  export const widgetDefs = {
    heading: Heading,
    image: Image,
    text: Text,
    puzzle: Puzzle,
    benefit: Benefit,
    audio: Audio,
    video: Video,
    link: Link,
    button: Button,
    margin: Margin,
    embed: Embed,
  };
</script>

<div
  class="locked-widget-container"
  class:vertical={orientation === "vertical"}
  class:horizontal={orientation === "horizontal"}
>
  {#each widgets as widget}
    <div class="locked-widget" class:debug={$debug} data-type={widget.type}>
      <svelte:component this={widgetDefs[widget.type]} {...widget} />
    </div>
  {/each}
</div>

<style>
  .locked-widget-container {
    display: flex;
    flex-direction: row;
    gap: 1em;
    align-items: center;
  }

  .locked-widget-container.horizontal {
    flex-direction: row;
  }

  .locked-widget-container.vertical {
    flex-direction: column;
  }

  .locked-widget-container .locked-widget {
    flex: 1;
  }
</style>
